import { Switch, Route } from "react-router-dom";


import Home from "../pages/home";
import About from "../pages/about";
import Account from "../pages/account";
import Contact from "../pages/contact";
import GetStart from "../pages/get-start";
import Package from "../pages/package";
import UserHome from "../pages/user-home";
import LoginModel from "../components/Modals/login-model";
import ContactModel from "../components/Modals/contact-model";
import RegisterModel from "../components/Modals/register-model";
import PasswordModel from "../components/Modals/password-model";
import SubscribeModel from "../components/PackagePage/subscribe-model";
import AdminHome from "../pages/admin-home";


const Screens = () => {
  return (
    <div>
        <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/home" component={Home} />
            <Route exact path="/about" component={About} />
            <Route exact path="/contact" component={Contact} />
            <Route exact path="/account" component={Account}/>

            <Route exact path="/home/start" component={GetStart}/>
            <Route exact path="/home/package" component={Package}/>
            <Route exact path="/userhome" component={UserHome}/>
            <Route exact path="/adminhome" component={AdminHome}/>
    
            <Route path="/" component={Home} />
        </Switch>
        
        <LoginModel/>
        <ContactModel/>
        <RegisterModel/>
        <PasswordModel/>
        <SubscribeModel/>
    </div>
  );
};

export default Screens;
